import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class DevicesApi extends ApiModule {
	constructor() {
		super(ModulesMap.DEVICES, {
			entity: 'devices',
		})
	}

	getDeviceRawGpsParams(options = {}) {
		const config = {
			url: this.generateUrl(true, {
				suffix: 'raw_gps_params',
			}),
		}

		return this.apiRequestWrap(this.moduleName, config, options)
	}

	getDeviceParams(options = {}) {
		const config = {
			url: this.generateUrl(true, {
				suffix: 'params',
			}),
		}
		return this.apiRequestWrap(this.moduleName, config, options)
	}
}
